module.exports = __webpack_public_path__ + "static/media/glacier-garden.97e959d8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/glacier-garden.png
 ** module id = 182
 ** module chunks = 0
 **/